import { getSessionStorage } from '@common/utils/session/getSessionStorage'
import type { HelloBarStorageData } from './getUpdatedStorageData'

export const getHelloBarStorageData = (
    pageHelloBarId: number
): {
    singleHelloBarStorageData: HelloBarStorageData | undefined
    helloBarStorageData: HelloBarStorageData[] | undefined
} => {
    const helloBarStorage = getSessionStorage<string | undefined>('hello-bar-data')
    const helloBarStorageData: HelloBarStorageData[] | undefined = helloBarStorage
        ? (JSON.parse(helloBarStorage) as HelloBarStorageData[])
        : undefined
    const singleHelloBarStorageData: HelloBarStorageData | undefined = helloBarStorageData?.find(
        helloBar => helloBar.id === pageHelloBarId
    )
    return { singleHelloBarStorageData, helloBarStorageData }
}

export default getHelloBarStorageData
